import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { AbConfigSituator } from 'app/abstract/full-pages/config-situator/config-situator.abstract';


@Injectable({ providedIn: 'root' })
export class ConfigSituatorService extends AbConfigSituator {

  constructor(http: HttpClient) {
    super(http);
  }

  public getConfigSituator(): Observable<any> {
    return this.get(`public/config_situator`);
  }

  public testeConexao(obj): Observable<any> {
    return this.save(`config_situator/teste_conexao`, obj);
  }

  public salvar(obj): Observable<any> {
    return this.save(`config_situator/`, obj);
  }

  public getContaSituator(contaId): Observable<any> {
    return this.get(`config_situator/conta/${contaId}`);
  }

  public getContasSituator(): Observable<any> {
    return this.get(`config_situator/contas/`);
  }

  public getAllConfigAvancadas(): Observable<any> {
    return this.get(`config_integracao/all`);
  }

  public salvarAvancadas(objs): Observable<any> {
    return this.save(`config_integracao/saveall/`, objs);
  }

  public sincronizarPessoas(contaId): Observable<any> {
    return this.get(`integracao_pessoa_situator/pessoas/${contaId}`);
  }
}